export function someToArray(inputData) {
  if (!inputData) return [];

  if (Array.isArray(inputData)) return inputData;
  if (typeof inputData == 'object') return Object.values(inputData);

  return [inputData];
}
